<script lang="ts">
	import { onMount } from "svelte";
	import About from "./About.svelte";
	import Contact from "./Contact.svelte";
	import Nav from "./Nav.svelte";
	import VideoList from "./VideoList.svelte";

	let bio = ``;

	let navigation = [
		{
			label: "about",
			isActive: false,
		},
		{
			label: "talks",
			isActive: false,
		},
		{
			label: "games",
			isActive: false,
		},
		{
			label: "contact",
			isActive: false,
		},
	];

	let talks = {
		title : "Talks I've Given",
		anchor: "talks",
		videos : [
			{
				title: "GDC Talk : Bleeding-Edge Effects on Mobile",
				id: "c7HBxBfCsas",
			},
			{
				title: "Realtime live 2019",
				id: "TKI_W5aRHh8",
			},
			{
				title: "Realtime live 2018",
				id: "VFP6MCykBqA",
			}
		]};

	let games = {
		title : "Games I've Worked On",
		anchor: "games",
		videos : [
			{
				title: "Saints Row",
				id: "M6tPdwPvHW0"
			},
			{
				title: "Virtual Technicque Guide",
				id: "Tj28fJgUZkY"
			},
			{
				title: "Top Derm",
				id: "Z5rwCEv4cZ4",
			},
			{
				title: "Cardio Ex",
				id: "1eplp1s0tG0",
			},
			{
				title: "Pulm Ex",
				id: "lCoxYWU-bOo",
			},
			{
				title: "Gastro Ex",
				id: "fk3hOtUwgyA",
			},
			{
				title: "Airway Ex",
				id: "3-GY7KTmJdo",
			},
			{
				title: "Path to Luma",
				id: "KtTJiUWRBX0",
			},
			{
				title: "Corpse of Discovery",
				id: "ki2JQtXVXQA",
			}
		]};

	let isMounted = false;

	onMount(() => {
		isMounted = true;
		updateActiveNav();
	});

	function updateActiveNav() {
		if (!isMounted) return;
		for (let i = 0; i < navigation.length; i++) {
			navigation[i].isActive = false;
		}

		for (let i = navigation.length - 1; i >= 0; i--) {
			let header = document.getElementsByClassName("nav-container")[0];
			let element = document.getElementById(navigation[i].label);
			if (element != null)
			{
				navigation[i].isActive = window.scrollY >= element.offsetTop - header.clientHeight;
				if (navigation[i].isActive) {
					break;
				}
			}
		}
	}
</script>

<svelte:window on:scroll={updateActiveNav} />

<Nav navigation={navigation}/>

<About bio={bio}/>

<VideoList videos={talks.videos} title={talks.title} anchor={talks.anchor} largeVideos="large"/>

<VideoList videos={games.videos} title={games.title} anchor={games.anchor} largeVideos="small"/>

<Contact/>